import { Star } from "lucide-react";

export const TestimonialsSection = ({ testimonials, title }: any) => {
    if (!testimonials || testimonials.length === 0) return null;

    return (
        <div className="py-12 px-4 bg-gray-50">
            <h2 className="text-3xl font-bold text-center mb-10">{title || "ماذا يقول عملاؤنا"}</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 container mx-auto">
                {testimonials.map((t: any, idx: number) => (
                    <div key={idx} className="bg-white p-6 rounded-lg shadow-sm">
                        <div className="flex gap-1 mb-4">
                            {[...Array(5)].map((_, i) => (
                                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                            ))}
                        </div>
                        <p className="text-gray-600 mb-4">"{t.comment}"</p>
                        <div className="font-bold">{t.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
